module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "language_switcher"
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('li', {
      key: locale,
      class: locale == _vm.$i18n.locale ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.switchLocale(locale)
        }
      }
    }, [_vm._v(_vm._s(locale))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6d326a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/partials/LanguageSwitcher.vue
// module id = 241
// module chunks = 0